import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { commonService } from "../../Network/services/commonService";
import { JobService } from "../../Network/services/JobService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";
import  ShareJob  from "../../components/ShareJob";
import ProfilePopup from "../ProfilePopup";

import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import Modal from "react-modal";
import GoogleMapReact from "google-map-react";

import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-dropdown-select";
import FilePreview from "../FilePreview";


const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const MarkerComponent = ({ text }) => (
  <div style={{ 
    position: 'absolute',
    transform: 'translate(-50%, -100%)',
    zIndex: 1000
  }}>
    <div style={{
      width: 30,
      height: 30,
      backgroundColor: '#F57E1F',
      border: '3px solid white',
      borderRadius: '50% 50% 50% 0',
      transform: 'rotate(-45deg)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        transform: 'rotate(45deg)',
        color: 'white',
        fontSize: '12px',
        fontWeight: 'bold',
        width: '8px',
        height: '8px',
        backgroundColor: 'white',
        borderRadius: '50%'
      }}>      </div>
    </div>
    <div style={{ 
    position: 'absolute',
    transform: 'translate(-50%, -100%)',
    zIndex: 1000
  }}>
    <div style={{
      width: 30,
      height: 30,
      backgroundColor: '#F57E1F',
      border: '3px solid white',
      borderRadius: '50% 50% 50% 0',
      transform: 'rotate(-45deg)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        transform: 'rotate(45deg)',
        color: 'white',
        fontSize: '12px',
        fontWeight: 'bold',
        width: '8px',
        height: '8px',
        backgroundColor: 'white',
        borderRadius: '50%'
      }}>      </div>
    </div>
  </div>
  </div>
);

const RequestListView = (props) => {
  let location = useLocation();
  let history = useHistory();

  const [profile, setProfile] = useState({});
  const [name, setName] = useState("");
  const [requestedList, setRequestedList] = useState([]);
  const [awardedJoblist, setAwardedJoblist] = useState([]);

  const [loading, setLoading] = useState(false);
  const [IsClicked, setIsClicked] = useState(false);
  const [clickedData, setclickedData] = useState({});
  const [mapView, setMapView] = useState(false);
  const [openShareJob, setOpenShareJob] = useState(false);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [totalQuoteCount, setTotalQuoteCount] = useState(location.state.item.total_quote_count);
  const [planRefundEligibility, setPlanRefundEligibility] = useState({
    is_eligible_for_plan_refund: false,
    is_refunded: false
  });

  useEffect(() => {
    
    let user = JSON.parse(window.localStorage.getItem("UserData"));

    getQuoteList();
    fetchJobDetails();
    setName(user.first_name + " " + user.last_name);
    let personal_preference_name1_array = user.personal_preference_name1.split(
      ","
    );
  }, []);

  let back = (e) => {
    e.preventDefault();
    window.location.href = "/mycontracts";
  };

  const redirect = () => {
    history.push("/ExperienceUpdate");
  };
  const toggleModel = () =>{
    setOpenSharejob(prevCheck => !prevCheck);
  }
  const accept = () => {
    setLoading(true);

    const FormData = require("form-data");

    const form = new FormData();
    form.append("quote_id", clickedData.quote_id);

    commonService
      .CommonService("accept_quote", form)
      .then(async (res) => {
        if (res.status == 200) {
          getQuoteList();
          
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          history.goBack();
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchJobDetails = () => {
    const jobId = location.state.item.id;
    
    JobService.getJobById(jobId)
      .then(async (res) => {
        if (res.status === "200" && res.data && res.data.length > 0) {
          const jobData = res.data[0];
          if (jobData.plan_refund_eligibility) {
            setPlanRefundEligibility({
              is_eligible_for_plan_refund: jobData.plan_refund_eligibility.is_eligible_for_plan_refund || false,
              is_refunded: jobData.plan_refund_eligibility.is_refunded || false
            });
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching job details:", err);
      });
  };

  const handleRefund = () => {
    setLoading(true);

    const FormData = require("form-data");

    const form = new FormData();
    form.append("job_id", location.state.item.id);

    commonService
      .CommonService("refund_plan_amount", form)
      .then(async (res) => {
        if (res.status == 200) {
          setPlanRefundEligibility(prev => ({
            ...prev,
            is_refunded: true
          }));
          
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getQuoteList = () => {
    setLoading(true);

    const FormData = require("form-data");

    const form = new FormData();
    form.append("job_id", location.state.item.id);

    commonService
      .CommonService("my_contract_request_users", form)
      .then(async (res) => {
        if (res.status == 200) {

          setRequestedList(res.data);
          if (res.total_records !== undefined) {
            location.state.item.total_quote_count = res.total_records;
           setTotalQuoteCount(res.total_records);
          }
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const openUserDetail = (user_id) => {
    history.push('/user-detail/'+user_id);

  }

  const handleProfileIconClick = (userData) => {
    setSelectedUserData(userData);
    setShowProfilePopup(true);
  }

  const closeProfilePopup = () => {
    setShowProfilePopup(false);
    setSelectedUserData(null);
  }

  return (
    <section className="explore explore1 contract">
      <style>{`
        .request-list-plan-text.lite-plan-text span {
          color: #008B8A !important;
        }
      `}</style>
      <div className="container">
        <div className="banner">
          <div className="row">
            <div className="col-md-6">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <div onClick={back}>
                      <a href="#">
                        <i className="bx bx-chevron-left" /> Back to Jobs I posted
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 quote-detail-text-align-right">
              <a href="#" className="btn" onClick={(e)=>{
                    e.preventDefault();
                    toggleModel();
              }}>
                Share this Job
              </a>
            </div>
          </div>
        </div>
        <div className="explore-details">
          <div className="row">
            <div className="col-md-7">
              <p className="jobid">
                Job#{" "}
                <span>
                  {location.state.item.job_unique_id?.substr(
                    location.state.item.job_unique_id?.indexOf(" ") + 1
                  )}
                </span>
              </p>
              
              <h1 className="title">{location.state.item.job_title}</h1>
              
              <ul className="list-two">
                <li>
                  <a href="#!">
                    {location.state.item.job_location} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    {location.state.item.payment_term} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!" >
                  {location.state.item.timestamp} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    Targeted close date {location.state.item.target_closed_date}{" "}
                    <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    {totalQuoteCount} Quotes Received
                  </a>
                </li>
              </ul>
              
              <p className="job-details-label quote-detail-job-label-no-margin">Project Budget</p>
              <div className="payment-amount">
                ₹{location.state.item.amount}
              </div>
              
              <p className="job-details-label">Category</p>
              <div className="job-category">
                {location.state.item?.parent_category_name && location.state.item?.category_full_name
                  ? `${location.state.item.parent_category_name} > ${location.state.item.category_full_name}`
                  : location.state.item?.category_full_name || location.state.item?.category || 'General'}
              </div>

              {location.state.item?.latitude && location.state.item?.longitude && (
                <span>
                  <p className="job-details-label" style={{ marginBottom: '0px' }}>Location</p>
                  <a
                    href="#!"
                    onClick={(e) => { e.preventDefault(); setMapView(true); }}
                    style={{ textDecoration: 'underline', color: '#007bff', cursor: 'pointer' }}
                  >
                    View On Map
                  </a>
                </span>
              )}

              {location.state.item?.skills && (
                <>
                  <p className="job-details-label">Required Skills</p>
                  <ul className="category-list">
                    {location.state.item.skills.split(',').map((skill, index) => (
                      <li key={index} className="skill-tag">
                        {skill.trim()}
                      </li>
                    ))}
                  </ul>
                </>
              )}
              
              <p className="job-details-label quote-detail-job-label-no-margin">About Job</p>
              <p>{location.state.item.job_description}</p>
              
              {location.state.item?.attach_file && location.state.item.attach_file.length > 0 && (
                <>
                  <p className="job-details-label">Attachments</p>
                  <div className="form-group myresume-file-preview-container">
                    {location.state.item.attach_file.split(",").map((file, index) => (
                      <FilePreview
                        key={index}
                        fileUrl={file}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className="col-md-5">
              <section className="profile you-quoted share status">
                {!IsClicked ? (
                  <LoadingOverlay>
                    <div className="container">
                      {!loading && (
                        <>
                          <div className="row">
                            <div className="col-md-6 padding-0">
                              <h3>
                                <span>{totalQuoteCount}</span>{" "}
                                Requests on this Job
                              </h3>
                            </div>
                              {(planRefundEligibility.is_eligible_for_plan_refund || planRefundEligibility.is_refunded )&& (
                              <div className="row">
                                <div className="col-md-6 padding-0" style={{marginBottom: '20px', marginLeft: '10px'}}>
                                  <a
                                    href="#"
                                    className={` ${planRefundEligibility.is_refunded ? "refund-initiated-status" : "btn quote"}`}
                                    style={planRefundEligibility.is_refunded ? { color: '#F57E1F', textDecoration: 'underline', cursor: 'default' } : {}}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (!planRefundEligibility.is_refunded) {
                                        handleRefund();
                                      }
                                    }}
                                  >
                                    {planRefundEligibility.is_refunded ? "Refund Initiated" : "Request Refund"}
                                  </a>
                                </div>
                              </div>
                                )}
                          </div>
                          {requestedList && requestedList.length > 0 ? (
                          requestedList.map((item, index) => (
                        <div key={index} className="quote-card">
                        <div className="quote-card-header">
                          <div className="quote-profile-info">
                            <div className="quote-profile-avatar">
                              {item.profile_image!="" ? (
                                <img 
                                  src={`${item.profile_image.includes("https://") ? item.profile_image : `${process.env.REACT_APP_BACKEND_BASE_URL}/` +item.profile_image}`} 
                                  alt="Profile" 
                                  className="quote-avatar-img"
                                />
                              ) : (
                                <img 
                                  src="/assets/images/profile-avatar.png" 
                                  alt="Profile" 
                                  className="quote-avatar-img"
                                />
                              )}
                            </div>
                            
                            <div className="quote-profile-details">
                              <h3 className="quote-user-name">
                                {item.user_name}
                              </h3>
                              <div className="quote-skills-section">
                                <div className="skill-tags-container">
                                  {item.skills && item.skills.split(",").map((skill, index) => (
                                    <span key={index} className="skill-tag">
                                      {skill.trim()}
                                    </span>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          <div className="quote-amount-section">
                            <div className="quote-amount">
                              ₹{item.bid_amount}
                            </div>
                            <div className="quote-button-container">
                              <a
                                href="#"
                                className="btn quote-view-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setIsClicked(true);
                                  setclickedData(item);
                                }}
                              >
                                View Quote
                              </a>
                            </div>
                          </div>
                        </div>
                        
                        <div className="quote-details-grid">
                          <div className="quote-detail-item">
                            <div className="quote-detail-label">
                              Payment
                            </div>
                            <div className="quote-detail-value">
                              {item.job_bid_type}
                            </div>
                          </div>
                          
                          <div className="quote-detail-item">
                            <div className="quote-detail-label">
                              Rating
                            </div>
                            <div className="quote-detail-value quote-rating">
                              <i className="fa fa-star" style={{ color: '#ffc107', marginRight: '5px' }} />
                              {item.user_rating}
                            </div>
                          </div>
                          
                          <div className="quote-detail-item">
                            <div className="quote-detail-label">
                              Experience
                            </div>
                            <div className="quote-detail-value">
                              {item.projects_completed} Projects
                            </div>
                          </div>
                        </div>
                        </div>
                      ))
                          ) : (
                          <div className="no-quotes-message">
                           
                            {planRefundEligibility.is_eligible_for_plan_refund ?(
                              <p style={{ marginTop: '10px', color: '#666', fontSize: '14px' }}>
                                If no one applies for your job, you'll get a refund — the amount will be added to your wallet.
                              </p>
                            ) :  <p>No quotes received yet.</p>}
                          </div>
                          )}
                        </>
                      )}
                      <Loader loading={loading} />
                    </div>
                  </LoadingOverlay>
                ) : (
                  
                    <div className="contract-detail-container">
                       <div className="breadcrumps">
                          <ul>
                            <li>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setIsClicked(false);
                                }}
                              >
                                <i className="bx bx-chevron-left" /> Back
                              </a>
                            </li>
                          </ul>
                        </div>
                      <div className="contract-detail-card">
                        <div className="contract-header">
                          <h1 className="contract-title">{clickedData.job_title}</h1>
                          <p className="contract-job-id">
                            Job ID: {clickedData.job_unique_id} • {clickedData.job_location}
                          </p>
                        </div>

                        <div className="developer-profile-section">
                          <div className="profile-avatar">
                            <img
                              src={clickedData.profile_image && clickedData.profile_image !== ""
                                ? (clickedData.profile_image.includes("https://")
                                  ? clickedData.profile_image
                                  : `${process.env.REACT_APP_BACKEND_BASE_URL}/${clickedData.profile_image}`)
                                : "/assets/images/profile-avatar.png"
                              }
                              alt="Profile"
                              className="profile-image"
                            />
                          </div>
                          <div className="profile-info">
                            <h3 className="developer-name">{clickedData.user_name}</h3>
                            <div className="developer-location">
                              <i className="fa fa-map-marker" style={{ marginRight: '5px' }}></i>
                              <span>{clickedData.location}</span>
                            </div>
                          </div>
                          <div
                            className="profile-icon"
                            onClick={() => handleProfileIconClick(clickedData)}
                            style={{ cursor: 'pointer' }}
                          >
                            <img src="/assets/images/userProfileInfoIcon.svg" />
                          </div>
                        </div>

                        <div className="scope-section">
                          <h4 className="profile-section-title">Scope</h4>
                          <div className="scope-content">
                            <p className="scope-text">
                              {clickedData.work_scope}
                            </p>
                          </div>
                        </div>

                        <div className="payment-term-section">
                          <h4 className="profile-section-title">Payment Term</h4>
                          <p className="payment-term-value">{clickedData.payment_terms}</p>
                        </div>

                        <div className="bidding-amount-section">
                          <h4 className="profile-section-title">Bidding Amount</h4>
                          <p className="bidding-amount-value">₹{clickedData.bid_amount}</p>
                        </div>

                        <div className="dates-section">
                          <div className="date-item">
                            <h4 className="date-label">Start Date</h4>
                            <p className="date-value">{clickedData.created_at}</p>
                          </div>
                          <div className="date-item">
                            <h4 className="date-label">End Date</h4>
                            <p className="date-value">{clickedData.target_closed_date}</p>
                          </div>
                          <div className="date-item">
                            <h4 className="date-label">Target Date</h4>
                            <p className="date-value">{clickedData.target_closed_date}</p>
                          </div>
                        </div>

                        <div className="attachments-section">
                          <h4 className="profile-section-title">Attachments</h4>
                          {clickedData.attach_portfolio && clickedData.attach_portfolio.trim() !== "" ? (
                            <div className="attachments-grid">
                              {(() => {
                                const resolvedUrl = clickedData.attach_portfolio;
                                return (
                                    <FilePreview fileUrl={resolvedUrl} />                              
                                );
                              })()}
                            </div>
                          ) : (
                            <div className="no-attachments">
                              <div className="no-attachments-icon">
                                <i className="fa fa-file-o"></i>
                              </div>
                              <p className="no-attachments-text">No attachments provided</p>
                            </div>
                          )}
                        </div>

                        {clickedData.additional_comment && (
                          <div className="additional-conditions-section">
                            <h4 className="profile-section-title">Additional Message or Condition</h4>
                            <div className="conditions-content">
                              <p>{clickedData.additional_comment}</p>
                            </div>
                          </div>
                        )}

                        <div className="action-buttons">
                          <button
                            className="btn default-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              accept();
                            }}
                            style={{width: '100%'}}
                          >
                            Accept Awarded Job
                          </button>
                        </div>
                      </div>
                      <div className="manage-payments-card">
                          <h2 className="manage-payments-title">{clickedData.payment_terms == "By Milestone" ? (clickedData.payment_milestone && clickedData.payment_milestone.length > 1 ? "Milestone Details" : "Milestone Detail") : clickedData.payment_terms == "By Terms" ? (clickedData.payment_terms === "By FWS Term" ? "FWS Term Details" : "Term Details") : ("Completion Detail")} </h2>

                          {clickedData.payment_milestone && clickedData.payment_milestone.length > 0 ? (
                            <div className="payment-terms-grid">
                              {clickedData.payment_milestone.map((milestone, index) => (
                                <div key={index} className="payment-term-card">
                                  <div className="term-header">
                                    <div className="term-info">
                                      <h3 className="term-title">
                                        {clickedData.payment_terms === "By Milestone"
                                          ? `Milestone ${String(index + 1).padStart(2, '0')}`
                                          : clickedData.payment_terms === "By Terms"
                                            ? `Term ${String(index + 1).padStart(2, '0')}`
                                            : "On Completion"}
                                      </h3>
                                      <p className="term-description">
                                        {clickedData.payment_terms === "By Milestone"
                                          ? milestone.milestone_descriction || milestone.name
                                          : clickedData.payment_terms === "By Terms"
                                            ? (index === 0 ? "Planning & Setup Dev Environment"
                                              : index === 1 ? "Core Application Development"
                                                : "Final Testing & Launch")
                                            : clickedData.payment_terms === "By Completion"
                                              ? "Once Work Complete"
                                              : milestone.name}
                                      </p>
                                    </div>
                                    <div className="term-amount">
                                      ₹{milestone.amount}
                                      {clickedData.payment_terms === "By Terms" && (
                                        <span className="percentage">
                                          ({index === 0 ? "20%" : index === 1 ? "60%" : "20%"})
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  {/* <div className="term-status">
                                    <div className="status-indicator">
                                      <span className="status-bullet"></span>
                                      <span className="status-text">
                                        {milestone.status === "Escrow"
                                          ? "Secure Payment to start the Job"
                                          : milestone.status === "Completed"
                                            ? "Payment released & Term 1 Completed"
                                            : "Review & Confirm completion"}
                                      </span>
                                    </div>

                                    
                                  </div> */}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="no-payment-terms">
                              <p>No payment terms available for this job.</p>
                            </div>
                          )}
                        </div>

                        
                      {location.state.item.job_plan.is_premium === '0' ? 
                        <p 
                          className="request-list-plan-text lite-plan-text"
                          style={{ color: '#FF0000' }}
                        >
                          You are on <span>{location.state.item.job_plan.subscription_name} plan.</span> Escrow fund not available for fund protection and Payment terms must be directly discussed and agreed
                        </p> : 
                        <p 
                          className="request-list-plan-text"
                          style={{ color: '#682FA3' }}
                        >
                          You're on {location.state.item.job_plan.subscription_name} plan. Escrow, priority support, and more are included
                        </p>}
                       
                    </div>

                )}

              </section>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={mapView}
        onRequestClose={() => setMapView(false)}
        style={customStyles}
        contentLabel="Example Modal"
        scrollable={true}
      >
        <div className="modal-dialog loginpopup" role="document">
          <div className="modal-content">
            <div>
              <div className="modal-header">
                <h5 className="modal-title">
                  View Location on Map
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setMapView(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                {(() => {
                  const lat = parseFloat(location.state.item.latitude);
                  const lng = parseFloat(location.state.item.longitude);
                  const isValidLocation = !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;
                  
                  if (!isValidLocation) {
                    return (
                      <div style={{ height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' }}>
                        <p>Location data not available for this job.</p>
                      </div>
                    );
                  }
                  
                  return (
                    <GoogleMapReact
                      style={{ height: 400 }}
                      bootstrapURLKeys={{
                        key: process.env.REACT_APP_GOOGLE_LOCATION_API_KEY,
                      }}
                      defaultCenter={{
                        lat: lat,
                        lng: lng,
                      }}
                      defaultZoom={11}
                    >
                      <MarkerComponent 
                        lat={lat}
                        lng={lng}
                        text="Job Location"
                      />
                    </GoogleMapReact>
                  );
                })()}
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <ShareJob isOpen={openShareJob} toggle={toggleModel} jobId={location.state.item.id}/>
      
      <ProfilePopup 
        isOpen={showProfilePopup}
        onClose={closeProfilePopup}
        userData={selectedUserData}
      />

    </section>
  );
};
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    background: "transparent",
  },
  overlay: { zIndex: 1000 },
};
export default connect(mapStateToProps, mapDispatchToProps)(RequestListView);
